import {
  parseTracks,
  type BusinessProfile,
  type MerchantLifecycle,
} from "../types";
import { partitionTracks } from "./lifecycle-sheet-helpers";
import { OnboardingSpine } from "./OnboardingSpine";
import { LifecycleTransitionForm } from "./LifecycleTransitionForm";
import { LifecycleIdentitySection } from "./LifecycleIdentitySection";
import { OtherTracksStrip } from "./OtherTracksStrip";

interface LifecycleSheetProps {
  lifecycle: MerchantLifecycle | null;
  business: BusinessProfile;
  onRefresh: () => void | Promise<void>;
  onTrackClick: (trackName: string) => void;
}

export function LifecycleSheet({
  lifecycle,
  business,
  onRefresh,
  onTrackClick,
}: LifecycleSheetProps) {
  const tracks = lifecycle ? parseTracks(lifecycle.tracks) : {};
  const { onboarding } = partitionTracks(tracks);
  const trackStage = onboarding?.stage ?? null;
  const mirrorStage = business.onboardingStage ?? null;

  return (
    <div className="bg-card rounded-lg border p-6">
      <h2 className="text-foreground mb-4 text-sm font-semibold">Lifecycle</h2>
      <OnboardingSpine
        trackStage={trackStage}
        mirrorStage={mirrorStage}
        history={lifecycle?.history ?? null}
        metadata={onboarding?.metadata}
      />
      <LifecycleTransitionForm
        businessId={business.id}
        tracks={tracks}
        onTransitionComplete={onRefresh}
      />
      <LifecycleIdentitySection
        business={business}
        lifecycle={lifecycle}
        onRefresh={onRefresh}
      />
      <OtherTracksStrip tracks={tracks} onTrackClick={onTrackClick} />
    </div>
  );
}
